import React from 'react';
import FamilyMigrationMap from '../FamilyMap/FamilyMigrationMap';

const MapIntegration = ({ selectedDocuments, conversationId }) => {
  const [showMap, setShowMap] = React.useState(false);

  if (!selectedDocuments || selectedDocuments.length === 0) {
    return null;
  }

  return (
    <div className="map-integration-container">
      <div style={{
        margin: '20px 0',
        textAlign: 'center',
        borderTop: '1px solid #e5e5e5',
        paddingTop: '20px'
      }}>
        <button 
          onClick={() => setShowMap(!showMap)}
          style={{
            padding: '12px 24px',
            background: showMap ? '#6c757d' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
            marginBottom: '20px'
          }}
        >
          📍 {showMap ? 'Hide' : 'View'} Family Migration Map ({selectedDocuments.length} documents)
        </button>
      </div>

      {showMap && (
        <div style={{ marginBottom: '30px' }}>
          <FamilyMigrationMap 
            documents={selectedDocuments}
            conversationId={conversationId}
            familyName="Family"
          />
        </div>
      )}
    </div>
  );
};

export default MapIntegration;
